/**
 * Service for tracking and reporting boost campaign interactions.
 *
 * Responsibilities:
 * - Report profile click events for a boost campaign.
 */
import type { ApiClient } from "@/common/api/http/types";

export default class BoostService {
  public constructor(private readonly client: ApiClient) {}

  async addProfileClick(params: { campaignId: string; pathname: string }): Promise<void> {
    const { campaignId, pathname } = params;
    return await this.client.post(`v2/boost/campaigns/${campaignId}/profile_click`, {
      source: pathname
    });
  }
}
